exports.init = function () {
    var $cache = {};
    $cache.document = $(document);
    $cache.nameField = $('.js-input-name');
    $cache.address1Field = $('.js-input-address1');
    $cache.cityField = $('.js-input-city');
    $cache.eircodeField = $('.js-input-eircode');
    $cache.dateRadios = $('.returns-collection-date-radio');
    $cache.countyField = $('[class*="js-input-county"]');
    $cache.submitButton = $('#collection-submit-button');

    function validateField($field) {
        return $field.length > 0 && $field.val().trim() !== '';
    }

    function validateSelectField($field) {
        return $field.length > 0 && $field.val() !== '' && $field.val() !== null;
    }

    function checkFormValidity() {
        var isNameValid = validateField($cache.nameField);
        var isAddress1Valid = validateField($cache.address1Field);
        var isCityValid = validateField($cache.cityField);
        var isEircodeValid = validateField($cache.eircodeField);
        var isDateSelected = $cache.dateRadios.is(':checked');
        var isCountyValid = validateSelectField($cache.countyField);

        var isFormValid = isNameValid && isAddress1Valid && isCityValid && isEircodeValid && isDateSelected && isCountyValid;
        $cache.submitButton.prop('disabled', !isFormValid);
    }

    $cache.document.on('input change', '.js-input-name, .js-input-address1, .js-input-address2, .js-input-city, .js-input-eircode, .returns-collection-date-radio, .js-input-countyIE, js-input-countyNI', function () {
        checkFormValidity();
    });

    checkFormValidity();
};
